import { useState, useEffect, useRef, Fragment, RawHTML } from '@wordpress/element';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';

import { useGlobalState } from '../state';
import { additional } from '../../../../../wp-includes/js/dist/vendor/wp-polyfill-url';
export default function BeefRecipe(props) {
    const { recipe_id } = props;
    console.log(recipe_id)
    const { fetchRecipe } = useGlobalState();
    const [recipe, setRecipe] = useState();
    const [recipeImage, setRecipeImage] = useState();

    const Section = styled(Paper)(({ theme }) => ({
        ...theme.typography.body2,
        color: theme.palette.text.secondary,
        padding: '2em',
        margin: '1em'
    }));

    const ingredientList = (ingredients) => {
        let output = '<ul style="list-style: none;">';

        let currentSubheading = null;

        // Loop through the items and create li elements accordingly
        ingredients.forEach(item => {
            if (item.subheading && item.subheading !== currentSubheading) {
                // If there is a subheading, create a bold li element for the subheading

                output = output + '<li><b>' + item['subheading'] + '</b></li>';
                currentSubheading = item.subheading; // Update the current subheading

            }
            if (item.recipeAsIngredient) {
                output = output + '<li><a href="/recipes/recipe?recipe=' + item.recipeAsIngredient.recipeID + '" target="_blank">' + item['ingredientText'] + '</a></li>'
            } else {
                output = output + '<li>' + item['ingredientText'] + '</li>';
            }
        });

        output = output + '</ul>'

        return output;

    }

    useEffect(() => {
        if (!recipe) return;
        const image = 'https://' + recipe.media[0].links[0].href
        setRecipeImage(image);
    }, [recipe])

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        if (queryParams.get('recipe')) {
            fetchRecipe({ recipe_id: queryParams.get('recipe') }).then((data) => {
                setRecipe(data);
            });
        } else {

            fetchRecipe({ recipe_id: recipe_id }).then((data) => {
                setRecipe(data);
            });
        }
    }, []);


    return (<Fragment>
        <Box sx={{ flexGrow: 1 }} >

            {recipe && (
                <Box>


                    <Box component="div" sx={{
                        marginBottom: '50px',
                    }}>
                        <Grid container key="container">
                            <Grid item xs={12} md={5} sx={{ paddingTop: '0px' }}>

                                <img src={recipeImage} />
                            </Grid>
                            <Grid item xs={12} md={7} sx={{ background: '#000', padding: '1em', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                <Typography variant="h2" component="div" sx={{ color: '#fff', textTransform: 'uppercase', textAlign: 'center' }}>
                                    {recipe.recipeName}
                                </Typography>
                                <Typography variant="h6" component="div" sx={{ color: '#fff', textAlign: 'center' }}>
                                    {recipe.recipeDescription}
                                </Typography>
                            </Grid>
                        </Grid>

                    </Box>

                    <Section elevation={8}>
                        <Typography gutterBottom variant="h5" component="div" style={{ textTransform: 'uppercase', 'color': '#ff0000' }}>Ingredients</Typography>
                        <Typography variant="body2" color="text.secondary" component="div">

                            <RawHTML>{ingredientList(recipe.ingredients)}</RawHTML>
                        </Typography>
                    </Section>
                    <Section elevation={8}>
                        <Typography gutterBottom variant="h5" component="div" style={{ textTransform: 'uppercase', 'color': '#ff0000' }}>Cooking</Typography>
                        <Typography variant="body2" color="text.secondary" component="div">
                            <ol>
                                {recipe.instructions.map((step, index) => {
                                    return (<li key={index}><RawHTML>{step.instructionText}</RawHTML></li>)
                                })}
                            </ol>
                        </Typography>
                    </Section>
                    <Section elevation={8}>
                        <Typography gutterBottom variant="h5" component="div" style={{ textTransform: 'uppercase', 'color': '#ff0000' }}>Safe Handling Tips</Typography>
                        <Typography variant="body2" color="text.secondary" component="div">
                            <ul>
                                <li>Wash hands with soap and water before cooking and always after touching raw meat.</li>
                                <li>Separate raw meat from other foods.</li>
                                <li>Wash all cutting boards, utensils, and dishes after touching raw meat.</li>
                                <li>Do not reuse marinades used on raw foods.</li>
                                <li>Wash all produce prior to use.</li>
                                <li>Cook steaks and roasts until temperature reaches 145°F for medium rare, as measured by a meat thermometer, allowing to rest for three minutes.</li>
                                <li>Cook Ground Beef to 160°F as measured by a meat thermometer.</li>
                                <li>Refrigerate leftovers promptly.</li>
                            </ul>
                        </Typography>

                    </Section>
                    <Section elevation={8}>
                        <Typography gutterBottom variant="h5" component="div" style={{ textTransform: 'uppercase', 'color': '#ff0000' }}>Nutrition</Typography>
                        <Typography variant="body2" color="text.secondary" component="div">
                            {recipe.nutritionals.map((nutritional, index) => {
                                return <RawHTML>{nutritional.nutritionalText}</RawHTML>
                            })}
                        </Typography>
                    </Section>
                </Box>


            )}

        </Box>

    </Fragment>)
}